import React from "react";
// import { useNavigate } from "react-router-dom";
// import { API, BASE_URL } from "../api/apiSlice";

const EmojiButton = ({ entry, capture }) => {
  // const navigate = useNavigate();

  const handleClick = (e) => {
    // ISO ignores the timezone hence the solution
    // var tzoffset = new Date().getTimezoneOffset() * 60000;
    var isoDate = new Date().toISOString();
    const feedbackId = entry._id;
    const clickedAt = isoDate;
    capture(feedbackId, clickedAt);
  };
  return (
    <button
      type="button"
      onClick={handleClick}
      className="col-span-3 flex flex-col sm:gap-4 gap-2 justify-center items-center"
    >
      <img
        src={`assets/emojifill/e${entry.rating}.svg`}
        alt=""
        className="sm:w-[180px] sm:h-[180px] h-[120px] w-[120px]"
      />
      <span className="uppercase font-medium text-center tracking-wide">
        {entry.title}
      </span>
    </button>
  );
};

export default EmojiButton;
